// Translation: English > Status
const status = Object.freeze({
	loadingData: 'Loading data',
	updatingData: 'Updating data'
})

// Export
export default status
